import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { MarketplaceBrokerUserInfo } from '../models/broker';

export const GetBrokersList = createAsyncThunk(
    'marketplaceBrokers/getBrokersList',
    async (_, dispatch: any) => {
        try {
            const axios = dispatch.getState().core.axios;

            const response = await axios.get(
                `/api/Marketplace/MarketplaceBrokers/list`
            );

            if (response.status !== 200) {
                throw new Error('Failed to fetch brokers');
            }

            return {
                brokersList: response.data as MarketplaceBrokerUserInfo[],
            };
        } catch (error) {
            createNotification(
                'An error occurred while fetching brokers list.',
                'error'
            );
            throw error;
        }
    }
);
